// Angular Module
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Location } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { WizardComponent } from "angular-archwizard";

// Ng Module
import {
  NgbCalendar,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { DragulaService } from "ng2-dragula";

// RXJS Module
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";

// Ngx Module
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

// Internal Module
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { ExercicioComponent } from "app/personal/pages/exercicios/pages/exercicio/exercicio.component";
import { CustomAdapter } from "app/shared/services/dateAdapter.service";
import { CustomDateParserFormatter } from "app/shared/services/dateParserFormatter.service";
import introJs from "intro.js";
import { IntroStep } from "intro.js/src/core/steps";
import * as moment from "moment";
import { ClipboardService } from "ngx-clipboard";
import Api from "../../../helpers/api";
import App from "../../../helpers/app";
import Me from "../../../helpers/me";

@Component({
  selector: "app-treino-detail",
  templateUrl: "./treino-detail.component.html",
  styleUrls: ["./treino-detail.component.scss"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class TreinoDetailComponent implements OnInit {
  introJS = introJs();

  faLayerGroup = faLayerGroup;
  apiCall = this.api.new().silent();
  // At the top of my component class that implements the <wizard>
  @ViewChild(WizardComponent)
  public wizard: WizardComponent;
  BAG = "bag-one";
  subs = new Subscription();
  listaExercicios = [];
  listaExerciciosPrincipais = [];
  listaExerciciosFiltrados = [];
  listaExerciciosDeletadas = [];
  @Input() public relation;
  @Input() public group;
  @Input() public training;
  @Input() public canEdit;
  @Input() public isModel = false;
  @Input() public isExperimental = false;
  testCustomerData = null;
  currentIndex = 0;
  trainingModels = [];
  categoriesAndExercicies = [];
  exercicies = [];
  trainingModelselecionada = null;
  categoriaSelecionada = null;
  exercicioSelecionado = null;
  listaRequisicoes = [];
  listaRequisicoesDeletadas = [];
  tipos = [
    { id: 1, name: "Personalizado" },
    { id: 2, name: "Circuito" },
    { id: 3, name: "Intervalado" },
    { id: 4, name: "Avaliação" },
  ];
  velocidade = ["Lento", "Moderado", "Rápido", "Isométrico"];

  switchRepetitionAndDuration = true;
  switchExecutionAndDate = true;
  switchAquecimentoMode = false;
  switchPeriodizacaoMode = false;
  switchHideVariables = false;
  isVideo = null;
  isEditingExercise = false;
  exercicie = {
    tempId: null,
    id: null,
    name: null,
    url_video: null,
    url_gif: null,
    series: null,
    repetitions: null,
    duration: null,
    load: null,
    speed: null,
    breakTime: null,
    note: null,
    order: null,
    loadFeedback: null,
    repetitionFeedback: null,
    timeFeedback: null,
    category: null,
    progressions: null,
    timeDuration: null,
    showLoadFeedback: null,
    showRepetitionFeedback: null,
    showTimeFeedback: null,
    isAquecimento: null,
    conjugado: null,
    hideVariables: null,
    corporalLoad: null,
    inicio_youtube: null,
    fim_youtube: null,
    url_thumbnail: null,
    exerciseId: null,
  };
  showFeedback = false;

  idTreino = null;
  idExercicio = 0;
  tipoSelecionado = null;
  intervaloTreino = null;
  voltasTreino = null;
  observacoesTreino = null;
  isAddingProgression = false;
  progressions = [];
  progressionsDeletadas = [];
  isEditingProgression = false;
  progressionInEdit = null;
  newProgression = {
    id: null,
    execution: null,
    progressionDate: !this.switchExecutionAndDate
      ? moment(new Date()).format("YYYY-MM-DD")
      : null,
    series: null,
    repetitions: null,
    duration: null,
    timeDuration: null,
    load: null,
    speed: null,
    breakTime: null,
    note: null,
    status: false,
  };
  newTraining = {
    id: null,
    name: null,
    note: null,
    agendamento: null,
    vencimento: null,
    type: null,
    laps: null,
    breakTime: null,
    isExperimental: false,
    isModel: false,
    status: true,
    sellerCustomer: null,
    seller: null,
    previousTraining: null,
    group: null,
    exercises: [],
  };

  isOnTour = false;

  nomeTreino = null;
  agendamento: string = null;
  vencimento: string = null;
  ultimoTipoSelecionado = null;
  errorDate = false;
  decodedData = null;
  decodedTrainingType = null;
  userProgressDB = null;
  createdTraining = null;
  user = null;

  step8Clicked = false;
  step5Clicked = false;

  isLoading = true;

  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday());
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private dragulaService: DragulaService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private _location: Location,
    private app: App,
    private _sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private api: Api,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private clipboardApi: ClipboardService
  ) {
    this.route.params.subscribe((params) => {
      if (params["trainingdata"])
        this.decodedData = JSON.parse(atob(params["trainingdata"]));
    });

    this.me
      .get()
      .pipe(take(1))
      .toPromise()
      .then((user) => {
        this.user = user;

        this.me
          .login(this.user.email, this.user.password, this.apiCall)
          .then((user) => {
            this.user = user;
          });
      });
  }

  async ngOnInit() {
    const self = this;
    self.training = null;
    self.relation = null;
    self.canEdit = null;
    self.isModel = null;
    self.group = null;
    let training = null;

    await this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    self.relation = this.decodedData.relation ?? null;
    self.isModel = this.decodedData.isModel ?? null;
    self.group = this.decodedData.group ?? null;
    self.canEdit = this.decodedData.canEdit ?? null;

    if (!this.group && !this.relation && !this.isModel)
      this.router.navigate(["/page"]);

    if (this.decodedData.training) {
      if (this.decodedData.relation) {
        training = await self.apiCall
          .get(
            "training/edit/sellercustomer/" +
              this.decodedData.training +
              "/" +
              this.decodedData.relation
          )
          .pipe(take(1))
          .toPromise();
      } else if (this.decodedData.group) {
        training = await self.apiCall
          .get(
            "training/edit/group/" +
              this.decodedData.training +
              "/" +
              this.decodedData.group
          )
          .pipe(take(1))
          .toPromise();
      } else if (this.decodedData.isModel) {
        training = await self.apiCall
          .get("training/edit/model/" + this.decodedData.training)
          .pipe(take(1))
          .toPromise();
      }
    }

    if (training && training.return) {
      this.training = training.return;
      this.nomeTreino = this.training.name;
    }

    if (self.isOnTour) {
      const response = await self.apiCall
        .get<{
          id: number;
          name: string;
          email: string;
          password: string;
        }>("me/gettestecustomer")
        .pipe(take(1))
        .toPromise();

      if (response?.return) {
        self.testCustomerData = response.return;
      }
    }

    const categoriesAndExercicies = await this.apiCall
      .get("training/exercises/categories")
      .pipe(take(1))
      .toPromise();
    this.categoriesAndExercicies = categoriesAndExercicies.return;

    const trainings = await this.apiCall
      .get("training/personal/0")
      .pipe(take(1))
      .toPromise();
    if (trainings.return) {
      this.trainingModels = trainings.return;
      if (this.group) {
        this.trainingModels = this.trainingModels.filter((t) => t.type !== 4);
        this.tipos = this.tipos.filter((t) => t.id !== 4);
      }
    }

    if (this.training) {
      this.idTreino = this.training.id;
      this.preencheInputsTreino(this.training);
    }

    this.preparaAssociacao();
    await self.spinner.hide();
    this.isLoading = false;
  }

  async ngAfterViewInit() {
    const self = this;

    if (this.introJS) {
      this.introJS.onexit(function () {
        self.isOnTour = false;
        self.user.onboardingProgress = this._currentStep + 4;
        self.me.onboardingUpdate(self.user);
      });

      this.introJS.oncomplete(function () {
        self.router.navigate(["/page"]);
      });
    }
    if (this.decodedData.isOnTour && this.decodedData.isOnTour == true) {
      self.isOnTour = true;
    }
    if (self.isOnTour) {
      self.introJS.onbeforechange(async function (targetElement) {
        if (this._currentStep === 2) {
          await new Promise((resolve) => {
            let interval = setInterval(() => {
              if (
                $("#tour-step__9")
                  .ready(() => {})
                  .is(":visible") ||
                $("#tour-step__9-mobile")
                  .ready(() => {})
                  .is(":visible")
              ) {
                resolve(null);
                clearInterval(interval);
              }
            }, 200);
          });
        }

        $(document).ready(() => {
          $(".introjs-skipbutton").css({ float: "left" });
          $(".introjs-nextbutton").css({
            background: "#40C057",
            color: "white",
            "text-shadow": "none",
            border: "1px solid rgb(58 173 79)",
          });
          $(".introjs-donebutton").css({
            background: "#40C057",
            color: "white",
            "text-shadow": "none",
            border: "1px solid rgb(58 173 79)",
          });

          if (
            this._currentStep === 0 ||
            this._currentStep === 2 ||
            this._currentStep === 4
          ) {
            $(".introjs-prevbutton").hide();
          } else {
            $(".introjs-prevbutton").show();
          }

          if (this._currentStep === 4) {
            $(".introjs-nextbutton").hide();
            $(".introjs-donebutton").show();
          } else {
            $(".introjs-nextbutton").show();
          }

          if (this._currentStep === 1 && !self.step8Clicked) {
            self.step8Clicked = true;

            const nextBtn = document.getElementsByClassName(
              "introjs-nextbutton"
            )?.[0] as HTMLButtonElement;

            if (nextBtn) {
              nextBtn.onclick = () => {
                if (
                  targetElement &&
                  (targetElement.id === "tour-step__8" ||
                    targetElement.id === "tour-step__8-mobile")
                ) {
                  targetElement.click();
                  this.nextStep();
                }
              };
            }
          } else if (this._currentStep === 2) {
            // do nothing
          } else if (this._currentStep === 3 && !self.step5Clicked) {
            self.step5Clicked = true;

            const nextBtn = document.getElementsByClassName(
              "introjs-nextbutton"
            )?.[0] as HTMLButtonElement;

            if (nextBtn) {
              nextBtn.onclick = () => {
                if (targetElement && targetElement.id === "tour-step__10") {
                  targetElement.click();
                }
              };
            }
          } else {
            const nextBtn = document.getElementsByClassName(
              "introjs-nextbutton"
            )?.[0] as HTMLButtonElement;

            if (nextBtn) {
              nextBtn.onclick = () => this.nextStep();
            }
          }

          if (this._currentStep === 4) {
            let interval = setInterval(() => {
              const [customerEmailElement, customerPasswordElement] = [
                document.getElementById("copy-customer-email"),
                document.getElementById("copy-customer-password"),
              ];

              if (customerEmailElement && customerPasswordElement) {
                customerEmailElement.onclick = () => {
                  self.copyToClipboard(
                    self.testCustomerData ? self.testCustomerData.email : "",
                    "E-mail"
                  );
                };

                customerPasswordElement.onclick = () => {
                  self.copyToClipboard(
                    self.testCustomerData ? self.testCustomerData.password : "",
                    "Senha"
                  );
                };

                clearInterval(interval);
              }
            }, 500);
          }
        });

        return true;
      });

      const total = 11;

      const getStepTitleWithCurrentStep = (current: number) =>
        `<div class='w-100 text-center'><span class='d-block grey darken-1 font-size-3 font-size-md-4 text-bold-400'>Passo <b> ${current} </b> de <b> ${total} </b></span></div>`;

      let isMobile = true;
      $(document).ready(function () {
        let checkExist = setInterval(async function () {
          if (
            ($("#tour-step__8").is(":visible") ||
              $("#tour-step__8-mobile").is(":visible")) &&
            !self.isLoading
          ) {
            if ($("#tour-step__8-mobile").is(":visible") === false) {
              isMobile = false;
            }

            let steps: Partial<IntroStep>[] = [
              {
                element: "#tour-step__7",
                title: getStepTitleWithCurrentStep(7),
                intro:
                  "<div class='w-100 text-center'><span class='d-block'>Aqui você adiciona as informações do treino.</span></div>",
                scrollTo: "tooltip",
              },
              {
                element: "#tour-step__8",
                title: getStepTitleWithCurrentStep(8),
                intro:
                  "<div class='w-100 text-center'><span class='d-block'>Agora, vamos <b> adicionar os exercícios.</b></span></div>",
                scrollTo: "tooltip",
              },
              {
                element: "#tour-step__8-mobile",
                title: getStepTitleWithCurrentStep(8),
                intro:
                  "<div class='w-100 text-center'><span class='d-block'>Agora, vamos <b> adicionar os exercícios.</b></span></div>",
                scrollTo: "tooltip",
              },
              {
                element: "#tour-step__9",
                title: getStepTitleWithCurrentStep(9),
                intro:
                  "<div class='w-100 text-center'><span class='d-block'>Neste botão, você pode <b> adicionar exercícios.</b></span></div>",
                scrollTo: "tooltip",
              },
              {
                element: "#tour-step__9-mobile",
                title: getStepTitleWithCurrentStep(9),
                intro:
                  "<div class='w-100 text-center'><span class='d-block'>Neste botão, você pode <b> adicionar exercícios.</b></span></div>",
                scrollTo: "tooltip",
              },
              {
                element: "#tour-step__10",
                title: getStepTitleWithCurrentStep(10),
                intro:
                  "<div class='w-100 text-center'><span class='d-block'>Depois de terminar as edições do seu treino, é só <b> publicar!</b></span></div>",
                scrollTo: "tooltip",
              },
              {
                title: getStepTitleWithCurrentStep(11),
                intro: getTourLastStepContent({
                  email: self.testCustomerData
                    ? self.testCustomerData.email
                    : "",
                  password: self.testCustomerData
                    ? self.testCustomerData.password
                    : "",
                }),
                scrollTo: "tooltip",
              },
            ];

            if (isMobile) {
              steps = steps.filter(
                (x) =>
                  !x.element ||
                  (x.element &&
                    x.element != "#tour-step__9" &&
                    x.element != "#tour-step__8")
              );
            } else {
              steps = steps.filter(
                (x) =>
                  !x.element ||
                  (x.element && !(x.element as string).includes("m"))
              );
            }

            self.introJS.setOptions({
              nextLabel: "Próximo",
              doneLabel: "Concluir!",
              prevLabel: "Voltar",
              overlayOpacity: 0.2,
              hidePrev: true,
              exitOnOverlayClick: false,
              exitOnEsc: false,
              steps: steps,
              showBullets: false,
              showProgress: false,
            });

            await self.mockTreinoTutorial();

            self.introJS.start();

            clearInterval(checkExist);
          }
        }, 200);
      });
    } else if (this.decodedData.training == null) {
      let createdTraining = null;

      createdTraining = await self.apiCall
        .get("me/userparams/createdTraining")
        .pipe(take(1))
        .toPromise();

      self.userProgressDB = await self.apiCall
        .get("me/userprogress/createTraining")
        .pipe(take(1))
        .toPromise();

      self.createdTraining = createdTraining.return?.value;

      if (!self.userProgressDB.return && self.createdTraining != "true") {
        const id = null;
        const meta = "createTraining";
        const progress = 0;
        const maxProgress = 3;
        self.userProgressDB = self.me.registerUserProgress(
          id,
          meta,
          progress,
          maxProgress
        );
      } else {
        self.userProgressDB = self.userProgressDB.return;
      }
    }
  }

  isMobile = false;

  toggleTipoTreino() {
    this.resetaTreinoEExercicios();
    this.classificaLabelTipo(this.tipoSelecionado.id);
  }

  filterLista() {
    if (this.listaExercicios && this.listaExercicios.length > 0) {
      this.listaExerciciosPrincipais = this.listaExercicios.filter(
        (x) =>
          (x.conjugado == null && !this.getNameExercise(x)) ||
          (this.getNameExercise(x) &&
            x.conjugado != null &&
            !this.listaExercicios.find((y) => y.conjugado == x.tempId))
      );
    }
  }

  switchAquecimento($event) {
    this.exercicie.isAquecimento = $event;
    this.switchAquecimentoMode = $event;
  }
  switchPeriodizacao($event) {
    this.switchPeriodizacaoMode = $event;
  }

  liberaCadastroProgressao() {
    this.resetNewProgression();
    this.isAddingProgression = true;
  }
  cancelaCadastroProgressao() {
    this.isAddingProgression = false;
    this.isEditingProgression = false;
    this.progressionInEdit = null;
    this.resetNewProgression();
  }

  getTipoTreino() {
    if (this.training && this.training.type) {
      let tipo = this.tipos.find((x) => x.id == this.training.type);
      if (tipo) {
        return tipo.name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  cadastraProgressao() {
    if (this.newProgression.timeDuration) {
      let totalSeconds = 0;
      if (this.newProgression.timeDuration.hour)
        totalSeconds =
          totalSeconds + this.newProgression.timeDuration.hour * 60 * 60;
      if (this.newProgression.timeDuration.minute)
        totalSeconds =
          totalSeconds + this.newProgression.timeDuration.minute * 60;
      if (this.newProgression.timeDuration.second)
        totalSeconds = totalSeconds + this.newProgression.timeDuration.second;
      this.newProgression.duration = totalSeconds;
    }
    this.progressions.push(this.newProgression);
    this.resetNewProgression();
    this.isAddingProgression = false;
  }
  dropConjugado(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.conjugadosToAdmin.list,
      event.previousIndex,
      event.currentIndex
    );
    for (let c of this.conjugadosToAdmin.list) {
      if (
        this.conjugadosToAdmin.list[this.conjugadosToAdmin.list.indexOf(c) + 1]
      ) {
        c.conjugado =
          this.conjugadosToAdmin.list[
            this.conjugadosToAdmin.list.indexOf(c) + 1
          ].tempId;
      } else {
        c.conjugado = null;
      }
    }
    for (let e of this.listaExercicios) {
      const found = this.conjugadosToAdmin.list
        ? this.conjugadosToAdmin.list.find((x) => x.tempId == e.tempId)
        : null;
      if (found) {
        e.conjugado = found.conjugado;
      }
    }
    if (this.idTreino) {
      this.cadastrarTreino(false);
    }
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.listaExerciciosPrincipais,
      event.previousIndex,
      event.currentIndex
    );
    let novaLista = [];
    for (let e of this.listaExerciciosPrincipais) {
      novaLista.push(e);
      for (let c of this.conjugados) {
        const searching = c.list
          ? c.list.find((x) => x.tempId == e.tempId)
          : null;
        if (searching) {
          for (let z of c.list) {
            if (z.tempId != e.tempId) {
              novaLista.push(z);
            }
          }
        }
      }
    }
    if (this.listaExercicios.length == novaLista.length) {
      this.listaExercicios = [...novaLista];
    }
    if (this.idTreino) {
      this.cadastrarTreino(false);
    }
  }

  atualizaProgressao() {
    for (let p of this.progressions) {
      if (this.progressions.indexOf(p) == this.progressionInEdit) {
        p.execution = this.newProgression.execution;
        p.progressionDate = this.newProgression.progressionDate;
        p.series = this.newProgression.series;
        p.repetitions = this.newProgression.repetitions;
        p.note = this.newProgression.note;

        if (this.newProgression.timeDuration) {
          let totalSeconds = 0;
          if (this.newProgression.timeDuration.hour)
            totalSeconds =
              totalSeconds + this.newProgression.timeDuration.hour * 60 * 60;
          if (this.newProgression.timeDuration.minute)
            totalSeconds =
              totalSeconds + this.newProgression.timeDuration.minute * 60;
          if (this.newProgression.timeDuration.second)
            totalSeconds =
              totalSeconds + this.newProgression.timeDuration.second;
          p.duration = totalSeconds;
        }
        p.load = this.newProgression.load;
        p.speed = this.newProgression.speed;
        p.breakTime = this.newProgression.breakTime;
        p.note = this.newProgression.note;
        p.status = this.newProgression.status;
      }
    }
    this.resetNewProgression();
    this.isEditingProgression = false;
  }

  verifyNewProgression() {
    if (
      ((this.newProgression.execution && this.newProgression.execution > 1) ||
        this.newProgression.progressionDate) &&
      (this.newProgression.series ||
        this.newProgression.repetitions ||
        !(
          !this.newProgression.timeDuration ||
          (this.newProgression.timeDuration.hour == 0 &&
            this.newProgression.timeDuration.minute == 0 &&
            this.newProgression.timeDuration.second == 0)
        ) ||
        this.newProgression.load ||
        this.newProgression.speed ||
        this.newProgression.breakTime ||
        this.newProgression.note) &&
      (!this.progressions ||
        !this.progressions.find(
          (p) =>
            ((this.newProgression.execution &&
              p.execution == this.newProgression.execution) ||
              (this.newProgression.progressionDate &&
                p.progressionDate &&
                moment(p.progressionDate).isSame(
                  moment(this.newProgression.progressionDate)
                ))) &&
            this.progressions.indexOf(p) != this.progressionInEdit
        ))
    ) {
      return true;
    } else {
      return false;
    }
  }

  resetAllProgression() {
    this.progressionsDeletadas = [];
    this.progressions = [];
    this.isAddingProgression = false;
    this.isEditingProgression = false;
    this.progressionInEdit = null;
    this.resetNewProgression();
  }

  editProgression(progression) {
    this.resetNewProgression();
    this.isEditingProgression = true;
    this.progressionInEdit = this.progressions.indexOf(progression);
    let timeDuration = null;
    if (progression.duration) {
      progression.duration = Number(progression.duration);
      var h = Math.floor(progression.duration / 3600);
      var m = Math.floor((progression.duration % 3600) / 60);
      var s = Math.floor((progression.duration % 3600) % 60);
      timeDuration = { hour: h, minute: m, second: s };
    }
    if (progression.execution) {
      this.switchExecutionAndDate = true;
    } else {
      this.switchExecutionAndDate = false;
    }
    this.newProgression = {
      id: progression.id ? progression.id : null,
      execution: progression.execution ? progression.execution : null,
      progressionDate: progression.progressionDate
        ? moment(progression.progressionDate).format("YYYY-MM-DD")
        : null,
      series: progression.series ? progression.series : null,
      repetitions: progression.repetitions ? progression.repetitions : null,
      duration: progression.duration ? progression.duration : null,
      load: progression.load ? progression.load : null,
      timeDuration: timeDuration,
      speed: progression.speed ? progression.speed : null,
      breakTime: progression.breakTime ? progression.breakTime : null,
      note: progression.note ? progression.note : null,
      status: progression.status ? progression.status : false,
    };
  }
  deleteProgression(progression) {
    if (progression.id) {
      progression.deletedAt = true;
      this.progressionsDeletadas.push(progression);
    }
    this.cancelaCadastroProgressao();
    const found = this.progressions.indexOf(progression);
    if (found > -1) this.progressions.splice(found, 1);
  }

  resetNewProgression() {
    this.newProgression = {
      id: null,
      execution: null,
      progressionDate: !this.switchExecutionAndDate
        ? moment(new Date()).format("YYYY-MM-DD")
        : null,
      series: null,
      repetitions: null,
      duration: null,
      load: null,
      speed: null,
      breakTime: null,
      timeDuration: null,
      note: null,
      status: false,
    };
  }

  classificaLabelTipo(id) {
    switch (id) {
      case 1:
        this.ultimoTipoSelecionado = "Treino Personalizado";
        break;
      case 2:
        this.ultimoTipoSelecionado = "Treino Circuito";
        break;
      case 3:
        this.ultimoTipoSelecionado = "Treino Intervalado";
        break;
      case 4:
        this.ultimoTipoSelecionado = "Treino de Avaliação";
        break;
      default:
        this.ultimoTipoSelecionado = "";
        break;
    }
  }

  formatToDate(date) {
    if (date) {
      return moment(date, "DDMMYYYY").toDate();
    } else {
      return "";
    }
  }
  formatDate(date) {
    if (date) {
      return moment(date).format("DDMMYYYY");
    } else {
      return "";
    }
  }
  formatDateBrazil(date) {
    if (date) {
      return moment(date).format("DD/MM/YYYY");
    } else {
      return "";
    }
  }
  checkValidDate(date) {
    if (date) {
      const data = moment(date, "DDMMYYYY");
      return data.isValid();
    } else {
      return false;
    }
  }

  resetaTreinoEExercicios() {
    if (!this.idTreino) {
      this.agendamento = this.today;
    }
    this.newTraining = {
      id: null,
      name: null,
      note: null,
      agendamento: this.agendamento?.replace("/", "")?.replace("-", ""),
      vencimento: null,
      type: null,
      laps: null,
      breakTime: null,
      isExperimental: false,
      isModel: false,
      status: true,
      sellerCustomer: null,
      seller: null,
      previousTraining: null,
      group: null,
      exercises: [],
    };

    this.vencimento = null;
    this.listaExercicios = [];

    this.categoriaSelecionada = null;
    this.exercicioSelecionado = null;
    this.showFeedback = false;

    this.resetaExercicio();
  }

  async verificaTutorial() {
    const self = this;
    if (!this.isOnTour) {
      self.userProgressDB = await self.apiCall
        .get("me/userprogress/createTraining")
        .pipe(take(1))
        .toPromise();
      self.userProgressDB = self.userProgressDB.return;
      if (self.createdTraining != "true" && self.userProgressDB.progress < 1)
        await self.updateUserProgress();
    }
  }
  resetaExercicio() {
    this.exercicie = {
      tempId: null,
      id: null,
      name: null,
      url_video: null,
      url_gif: null,
      series: null,
      repetitions: null,
      duration: null,
      load: null,
      speed: null,
      breakTime: null,
      note: null,
      order: null,
      loadFeedback: null,
      repetitionFeedback: null,
      timeFeedback: null,
      category: null,
      progressions: null,
      timeDuration: null,
      showLoadFeedback: null,
      showRepetitionFeedback: null,
      showTimeFeedback: null,
      isAquecimento: null,
      conjugado: null,
      hideVariables: null,
      corporalLoad: null,
      inicio_youtube: null,
      fim_youtube: null,
      url_thumbnail: null,
      exerciseId: null,
    };
  }

  async updateUserProgress() {
    const self = this;
    self.userProgressDB = await self.apiCall
      .get("me/userprogress/createTraining")
      .pipe(take(1))
      .toPromise();
    self.userProgressDB = self.userProgressDB.return;
    const id = self.userProgressDB.id;
    const meta = self.userProgressDB.meta;
    const progress = self.userProgressDB.progress + 1;
    const maxProgress = self.userProgressDB.maxProgress;
    self.userProgressDB = self.me.registerUserProgress(
      id,
      meta,
      progress,
      maxProgress
    );
  }

  preencheInputsTreino(training) {
    this.newTraining = {
      ...training,
      breakTime: null,
      agendamento: training.agendamento
        ? this.formatDate(training.agendamento)
        : null,
      vencimento: training.vencimento
        ? this.formatDate(training.vencimento)
        : null,
    };

    const agendamento = this.newTraining.agendamento;
    const vencimento = this.newTraining.vencimento;

    const agendamentoSplited = agendamento
      ? moment(agendamento, "DDMMYYYY").format("DD/MM/YYYY").split("/")
      : null;
    if (agendamentoSplited) {
      this.agendamento = this.dateAdapter.toModel({
        day: Number(agendamentoSplited[0]),
        month: Number(agendamentoSplited[1]),
        year: Number(agendamentoSplited[2]),
      });
    }

    const vencimentoSplited = vencimento
      ? moment(vencimento, "DDMMYYYY").format("DD/MM/YYYY").split("/")
      : null;
    if (vencimentoSplited) {
      this.vencimento = this.dateAdapter.toModel({
        day: Number(vencimentoSplited[0]),
        month: Number(vencimentoSplited[1]),
        year: Number(vencimentoSplited[2]),
      });
    }

    if (!this.idTreino) {
      this.agendamento = this.today;
    }

    this.tipoSelecionado = this.tipos.find((t) => t.id == training.type);
    this.classificaLabelTipo(this.tipoSelecionado.id);
    this.nomeTreino = training.name;
    training.TrainingExercises.sort(function (a, b) {
      return a.order - b.order;
    });

    if (this.relation) {
      this.newTraining.breakTime = null;
    } else {
      training.duration = Number(training.breakTime);
      var h = Math.floor(training.duration / 3600);
      var m = Math.floor((training.duration % 3600) / 60);
      var s = Math.floor((training.duration % 3600) % 60);
      this.newTraining.breakTime = { hour: h, minute: m, second: s };
    }

    this.listaExercicios = [];
    this.listaExerciciosFiltrados = [];
    for (let i of training.TrainingExercises) {
      i.tempId = this.idExercicio++;
      i.disabled = false;
      if (i.repetitionsSt) {
        i.repetitions = i.repetitionsSt;
      }

      let prog = [];
      for (let p of i.TrainingExercisesProgressions) {
        prog.push({
          id: p.id,
          breakTime: p.breakTime,
          duration: p.duration,
          execution: p.execution,
          progressionDate: p.progressionDate,
          load: p.load,
          repetitions: p.repetitions,
          series: p.series,
          speed: p.speed,
          note: p.note,
          status: false,
        });
      }
      i.progressions = [];
      for (let p of prog) {
        i.progressions.push(p);
      }
      //i.TrainingExercisesProgressions = null
      this.listaExercicios.push(i);
    }
    for (let f of this.listaExercicios) {
      if (f.conjugado != null) {
        let found = this.listaExercicios
          ? this.listaExercicios.find((x) => f.conjugado == x.id)
          : null;
        if (found) {
          f.conjugado = found.tempId;
        }
      }
    }

    this.listaExerciciosFiltrados = [
      ...this.listaExercicios.filter((x) => !x.hideVariables),
    ];
    for (let e of this.listaExerciciosFiltrados) {
      e.disabled = false;
    }
    for (let e of this.listaExerciciosFiltrados) {
      if (
        this.listaExerciciosFiltrados &&
        this.listaExerciciosFiltrados.find(
          (x) => x.conjugado != null && x.conjugado == e.tempId
        )
      ) {
        e.disabled = true;
      }
    }

    this.filterLista();
  }

  verificaTreinoDeAvaliacaoPreenchido() {
    if (
      this.training &&
      this.training.type == 4 &&
      this.training.TrainingExecution &&
      this.training.TrainingExecution.length > 0
    ) {
      return true;
    }
    return false;
  }

  verificaEditarTreino() {
    if (this.training && this.training.id != null) {
      return true;
    }
    return false;
  }

  verificaPreenchimentoTreino() {
    const agendamento = moment(this.agendamento, "DD-MM-YYYY").toDate();
    const vencimento = moment(this.vencimento, "DD-MM-YYYY").toDate();

    if (
      this.vencimento &&
      moment.isDate(vencimento) &&
      moment(vencimento).isSame(agendamento, "day")
    ) {
      this.errorDate = true;
      return false;
    } else {
      this.errorDate = false;
    }

    if (!this.tipoSelecionado) {
      return false;
    }

    if (!this.newTraining.name) {
      return false;
    }

    if (
      (this.tipoSelecionado.id == 2 || this.tipoSelecionado.id == 3) &&
      (!this.newTraining.laps || this.newTraining.laps == 0)
    ) {
      return false;
    }

    return true;
  }

  getLabelCategory(category) {
    if (category) {
      let cat = this.categoriesAndExercicies
        ? this.categoriesAndExercicies.find((c) => c.id == category)
        : null;
      if (cat) {
        return cat.name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
  conjugadosToAdmin = {
    name: null,
    list: [],
  };

  resetAdminConjugado() {
    this.conjugadosToAdmin = {
      name: null,
      list: [],
    };
  }
  administrarConjunto(e, modalEditConjugado) {
    this.resetAdminConjugado();

    if (!this.conjugados) {
      return;
    }
    for (let c of this.conjugados) {
      const searching = c.list
        ? c.list.find((x) => x.tempId == e.tempId)
        : null;
      if (searching) {
        this.conjugadosToAdmin = {
          name: "Conjunto " + (this.conjugados.indexOf(c) + 1).toString(),
          list: c.list,
        };
        this.modalService.open(modalEditConjugado, { size: "xl" });

        break;
      }
    }
  }
  getNameExercise(e) {
    if (!this.conjugados) {
      return "";
    }
    let retorno = "";
    for (let c of this.conjugados) {
      const searching = c.list
        ? c.list.find((x) => x.tempId == e.tempId)
        : null;
      if (searching) {
        retorno = "Conjunto " + (this.conjugados.indexOf(c) + 1).toString();
        break;
      }
    }
    return retorno;
  }

  getResumoConjunto(e) {
    if (!this.conjugados) {
      return "";
    }
    let retorno = "";
    for (let c of this.conjugados) {
      const searching = c.list
        ? c.list.find((x) => x.tempId == e.tempId)
        : null;
      if (searching) {
        /*for(let t of c.list){
          retorno = retorno+' '+(c.list.indexOf(t)+1).toString()+' - '+t.name
        }*/
        retorno = c.list;
        break;
      }
    }
    return retorno;
  }

  verificaExercicio(exercicio) {
    if (exercicio) {
      if (
        this.idTreino &&
        this.training &&
        this.training.type == 4 &&
        (exercicio.loadFeedback ||
          exercicio.timeFeedback ||
          exercicio.repetitionFeedback)
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.exercicie) {
      if (
        this.idTreino &&
        this.training &&
        this.training.type == 4 &&
        (this.exercicie.loadFeedback ||
          this.exercicie.timeFeedback ||
          this.exercicie.repetitionFeedback)
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  onselectExercicio() {
    this.exercicie.name = null;
    this.exercicie.url_video = null;
    this.exercicie.url_gif = null;
    this.exercicie.category = null;
    this.isVideo = null;
    if (this.exercicioSelecionado) {
      this.exercicie.name = this.exercicioSelecionado.Exercise.name;
      this.exercicie.url_video = this.exercicioSelecionado.Exercise
        .url_video_blackbaze
        ? this.exercicioSelecionado.Exercise.url_video_blackbaze
        : this.exercicioSelecionado.Exercise.url_video;
      this.isVideo = true;
      this.exercicie.url_gif = null;
      this.exercicie.category = this.exercicioSelecionado.category;
      this.exercicie.inicio_youtube = this.exercicioSelecionado.Exercise
        .inicio_youtube
        ? this.exercicioSelecionado.Exercise.inicio_youtube
        : null;
      this.exercicie.fim_youtube = this.exercicioSelecionado.Exercise
        .fim_youtube
        ? this.exercicioSelecionado.Exercise.fim_youtube
        : null;
      this.exercicie.url_thumbnail = this.exercicioSelecionado.Exercise
        .url_thumbnail
        ? this.exercicioSelecionado.Exercise.url_thumbnail
        : null;
      this.exercicie.exerciseId = this.exercicioSelecionado.Exercise.id;
    }
  }
  onselectCategory() {
    this.exercicioSelecionado = null;
    this.exercicies = [];
    if (
      this.categoriaSelecionada &&
      this.categoriaSelecionada.ExercisesCategories &&
      this.categoriaSelecionada.ExercisesCategories.length > 0
    ) {
      this.categoriaSelecionada.ExercisesCategories =
        this.categoriaSelecionada.ExercisesCategories.sort((a, b) =>
          a.Exercise.name.localeCompare(b.Exercise.name)
        );
      this.exercicies = [...this.categoriaSelecionada.ExercisesCategories];
    }
  }

  addExercise() {
    const modalRef = this.modalService.open(ExercicioComponent, { size: "lg" });
    modalRef.result.then(
      () => {
        // on close
        this.apiCall
          .get("training/exercises/categories")
          .subscribe(async (data) => {
            this.spinner.hide();
            this.categoriesAndExercicies = data.return;
          });
        this.ngOnInit();
      },
      () => {
        // on dismiss
      }
    );
  }

  openExercise(modalExercicio) {
    this.cancelarAtualizacaoExercicio();
    this.modalService.open(modalExercicio, { size: "xl" });
  }

  getLabelAssociados(list) {
    if (!list || list.length == 0) {
      return "";
    }
    let retorno = "";
    for (let l of list) {
      if (list.indexOf(l) == 0) {
        retorno =
          retorno + (list.indexOf(l) + 1).toString() + " - " + l.name + " ";
      } else {
        retorno =
          retorno +
          " | " +
          (list.indexOf(l) + 1).toString() +
          " - " +
          l.name +
          " ";
      }
    }
    return retorno;
  }

  conjugados = [];
  openAssociar(modal) {
    this.preparaAssociacao();
    this.modalService.open(modal, { size: "xl" });
  }

  preparaAssociacao() {
    let listOfLists = [];
    if (
      !this.listaExercicios ||
      this.listaExercicios.length == 0 ||
      !this.tipoSelecionado ||
      this.tipoSelecionado.id != 1
    ) {
      return;
    }
    let id = 0;
    for (let e of this.listaExercicios) {
      e.disabled = false;
      let list = [];
      let found = this.listaExercicios
        ? this.listaExercicios.find((x) => x.conjugado == e.tempId)
        : null;
      if (e.conjugado == null && found) {
        list.push(e);
        list.push(found);
        let temMaisUm = true;
        while (temMaisUm) {
          found = this.listaExercicios
            ? this.listaExercicios.find((x) => x.conjugado == found.tempId)
            : null;
          if (found) {
            list.push(found);
          } else {
            temMaisUm = false;
          }
        }
        id = id + 1;
        listOfLists.push({
          id: id,
          list: list.reverse(),
        });
      }
    }
    this.conjugados = [...listOfLists];
  }

  addingOrUpdatingConjugado = false;
  idEditing = null;
  conjugadoAddingOrEditing = [];
  opcoesParaConjugar = [];
  liberaAddConjugado() {
    this.addingOrUpdatingConjugado = true;
    this.idEditing = null;
    this.conjugadoAddingOrEditing = [];

    let allTrainingConjugados = [];
    for (let a of this.conjugados) {
      for (let t of a.list) {
        allTrainingConjugados.push(t);
      }
    }
    let opcoesParaConjugar = this.listaExercicios.filter(
      (item) => allTrainingConjugados.indexOf(item) < 0
    );
    this.opcoesParaConjugar = [...opcoesParaConjugar];
  }
  liberaEditConjugado(c) {
    if (!c || !c.id || !c.list || c.list.length == 0) {
      return;
    }
    this.addingOrUpdatingConjugado = true;
    this.idEditing = c.id;
    this.conjugadoAddingOrEditing = [...c.list];
    this.opcoesParaConjugar = [...c.list];
    let allTrainingConjugados = [];
    for (let a of this.conjugados) {
      for (let t of a.list) {
        allTrainingConjugados.push(t);
      }
    }
    let opcoesParaConjugar = this.listaExercicios.filter(
      (item) => allTrainingConjugados.indexOf(item) < 0
    );
    if (opcoesParaConjugar) {
      for (let t of opcoesParaConjugar) {
        this.opcoesParaConjugar.push(t);
      }
    }
  }
  cancelaAddOuEditConjugado() {
    this.addingOrUpdatingConjugado = false;
    this.idEditing = null;
    this.conjugadoAddingOrEditing = [];
  }

  salvarConjugado() {
    let newConjugados = [...this.conjugadoAddingOrEditing];
    for (let c of newConjugados) {
      // c.series = this.conjugadoAddingOrEditing[0].series
      if (newConjugados[newConjugados.indexOf(c) + 1]) {
        c.conjugado = newConjugados[newConjugados.indexOf(c) + 1].tempId;
      } else {
        c.conjugado = null;
      }
    }
    if (this.idEditing) {
      for (let c of this.conjugados) {
        if (c.id == this.idEditing) {
          c.list = [...newConjugados];
        }
      }
    } else {
      this.conjugados.push({
        id: this.conjugados.length + 1,
        list: [...newConjugados],
      });
    }
    this.parseConjugadosToExercicios();
    this.cancelaAddOuEditConjugado();
    if (this.idTreino) {
      this.cadastrarTreino(false);
    } else {
      this.preparaAssociacao();
      this.filterLista();
    }
  }

  deletarConjugado(c) {
    if (!c) {
      return;
    }
    this.cancelaAddOuEditConjugado();
    const foundIndex = this.conjugados.indexOf(c);
    if (foundIndex > -1) this.conjugados.splice(foundIndex, 1);
    this.parseConjugadosToExercicios();
    if (this.idTreino) {
      this.cadastrarTreino(false);
    }
  }

  parseConjugadosToExercicios() {
    let allExercisesToUpdate = [];
    for (let c of this.conjugados) {
      if (c.list) {
        for (let e of c.list) {
          allExercisesToUpdate.push(e);
        }
      }
    }
    if (this.conjugados.length == 0) {
      for (let e of this.listaExercicios) {
        e.conjugado = null;
      }
    }
    if (allExercisesToUpdate && allExercisesToUpdate.length > 0) {
      for (let e of this.listaExercicios) {
        const found = allExercisesToUpdate.find((x) => x.tempId == e.tempId);
        if (found) {
          e.conjugado = found.conjugado;
          e.series = found.series;
        } else {
          e.conjugado = null;
        }
      }
    }
  }

  switchMidia(isVideo) {
    if (isVideo) {
      this.isVideo = true;
      this.exercicie.url_video = this.exercicioSelecionado.Exercise
        .url_video_blackbaze
        ? this.exercicioSelecionado.Exercise.url_video_blackbaze
        : this.exercicioSelecionado.Exercise.url_video;
      this.exercicie.url_gif = null;
    } else {
      this.isVideo = false;
      this.exercicie.url_gif = this.exercicioSelecionado.Exercise
        .url_gif_blackbaze
        ? this.exercicioSelecionado.Exercise.url_gif_blackbaze
        : this.exercicioSelecionado.Exercise.url_gif;
      this.exercicie.url_video = null;
    }
  }
  urlToPlay = null;
  safeURL = null;

  viewMidia(isVideo, contentVideo, contentGif) {
    if (isVideo) {
      //this.isVideo = true

      this.urlToPlay = this.exercicioSelecionado.Exercise.url_video_blackbaze
        ? this.exercicioSelecionado.Exercise.url_video_blackbaze
        : this.exercicioSelecionado.Exercise.url_video;
      // this.exercicie.url_video = this.exercicioSelecionado.Exercise.url_video_blackbaze ? this.exercicioSelecionado.Exercise.url_video_blackbaze : this.exercicioSelecionado.Exercise.url_video

      //this.exercicie.url_gif = null
      if (this.urlToPlay.startsWith("https://www.youtube.com/watch?")) {
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.urlToPlay.replace(
            "https://www.youtube.com/watch?v=",
            "https://www.youtube.com/embed/"
          )
        );
      } else if (this.urlToPlay.startsWith("http://www.youtube.com/watch?")) {
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.urlToPlay.replace(
            "http://www.youtube.com/watch?v=",
            "https://www.youtube.com/embed/"
          )
        );
      } else {
        this.safeURL = null;
      }
      this.modalService.open(contentVideo, { centered: true });
    } else {
      //this.isVideo = false

      this.urlToPlay = this.exercicioSelecionado.Exercise.url_gif_blackbaze
        ? this.exercicioSelecionado.Exercise.url_gif_blackbaze
        : this.exercicioSelecionado.Exercise.url_gif;
      //this.exercicie.url_gif = this.exercicioSelecionado.Exercise.url_gif_blackbaze ? this.exercicioSelecionado.Exercise.url_gif_blackbaze : this.exercicioSelecionado.Exercise.url_gif

      //this.exercicie.url_video = null
      this.modalService.open(contentGif, { centered: true });
    }
  }

  switchRepAndDur(event) {
    this.switchRepetitionAndDuration = event;
    this.exercicie.duration = null;
    this.exercicie.repetitions = null;
  }

  switchExeAndDate(event) {
    this.switchExecutionAndDate = event;
    this.newProgression.execution = null;
    this.newProgression.progressionDate = !this.switchExecutionAndDate
      ? moment(new Date()).format("YYYY-MM-DD")
      : null;
  }

  changeSwitchVariables(event) {
    this.switchHideVariables = event;
    if (this.switchHideVariables) {
      this.exercicie.hideVariables = true;
    } else {
      this.exercicie.hideVariables = null;
    }
  }

  verificaPrePreenchimentoExercicio() {
    if (!this.exercicie.url_video && !this.exercicie.url_gif) {
      return false;
    }
    return true;
  }

  verificaPreenchimentoExercicio() {
    if (!this.exercicioSelecionado) {
      return false;
    }
    if (!this.exercicie.url_video && !this.exercicie.url_gif) {
      return false;
    }
    if (this.exercicie.hideVariables) {
      return true;
    }
    if (
      this.tipoSelecionado.id == 1 &&
      (!this.exercicie.series ||
        this.exercicie.series == 0 ||
        ((!this.exercicie.breakTime || this.exercicie.breakTime == 0) &&
          this.exercicie.conjugado == null) ||
        ((!this.switchRepetitionAndDuration ||
          !this.exercicie.timeDuration ||
          (this.exercicie.timeDuration.hour == 0 &&
            this.exercicie.timeDuration.minute == 0 &&
            this.exercicie.timeDuration.second == 0)) &&
          (this.switchRepetitionAndDuration ||
            !this.exercicie.repetitions ||
            this.exercicie.repetitions == 0)))
    ) {
      return false;
    }

    if (
      this.tipoSelecionado.id == 2 &&
      (!this.switchRepetitionAndDuration ||
        !this.exercicie.timeDuration ||
        (this.exercicie.timeDuration.hour == 0 &&
          this.exercicie.timeDuration.minute == 0 &&
          this.exercicie.timeDuration.second == 0)) &&
      (this.switchRepetitionAndDuration ||
        !this.exercicie.repetitions ||
        this.exercicie.repetitions == 0)
    ) {
      return false;
    }
    if (
      this.tipoSelecionado.id == 3 &&
      (((!this.switchRepetitionAndDuration ||
        !this.exercicie.timeDuration ||
        (this.exercicie.timeDuration.hour == 0 &&
          this.exercicie.timeDuration.minute == 0 &&
          this.exercicie.timeDuration.second == 0)) &&
        (this.switchRepetitionAndDuration ||
          !this.exercicie.repetitions ||
          this.exercicie.repetitions == 0)) ||
        !this.exercicie.breakTime ||
        this.exercicie.breakTime == 0)
    ) {
      return false;
    }

    if (this.switchRepetitionAndDuration) {
      this.exercicie.repetitions = null;
    } else {
      this.exercicie.duration = null;
      this.exercicie.timeDuration = null;
    }

    if (
      this.tipoSelecionado.id == 4 &&
      !this.exercicie.showRepetitionFeedback &&
      !this.exercicie.showTimeFeedback &&
      !this.exercicie.showLoadFeedback
    ) {
      return false;
    }
    return true;
  }

  async adicionarExercicio(modal) {
    if (this.isVideo) {
      this.exercicie.url_gif = null;
    } else {
      this.exercicie.url_video = null;
      this.exercicie.inicio_youtube = null;
      this.exercicie.fim_youtube = null;
    }
    this.exercicie.tempId = this.idExercicio++;
    let progressionsToSend = [];
    for (let p of this.progressions) {
      progressionsToSend.push(p);
    }
    for (let p of this.progressionsDeletadas) {
      progressionsToSend.push(p);
    }
    this.exercicie.progressions = progressionsToSend;
    if (this.switchRepetitionAndDuration) {
      this.exercicie.repetitions = null;
    } else {
      this.exercicie.duration = null;
      this.exercicie.timeDuration = null;
    }

    if (this.exercicie.timeDuration) {
      let totalSeconds = 0;
      if (this.exercicie.timeDuration.hour)
        totalSeconds =
          totalSeconds + this.exercicie.timeDuration.hour * 60 * 60;
      if (this.exercicie.timeDuration.minute)
        totalSeconds = totalSeconds + this.exercicie.timeDuration.minute * 60;
      if (this.exercicie.timeDuration.second)
        totalSeconds = totalSeconds + this.exercicie.timeDuration.second;
      this.exercicie.duration = totalSeconds;
    }

    if (this.exercicie.conjugado != null) {
      this.exercicie.breakTime = 0;

      let searchFront = { ...this.exercicie };
      while (searchFront.conjugado != null) {
        for (let z of this.listaExercicios) {
          if (z.tempId == searchFront.conjugado) {
            z.series = searchFront.series;
            z.isAquecimento = searchFront.isAquecimento;
            searchFront = { ...z };
          }
        }
      }
    }

    this.listaExercicios.push(this.exercicie);
    this.listaExerciciosFiltrados = [];
    this.listaExerciciosFiltrados = [
      ...this.listaExercicios.filter((x) => !x.hideVariables),
    ];
    this.exercicioSelecionado = null;
    this.categoriaSelecionada = null;
    this.showFeedback = false;
    this.switchHideVariables = false;
    this.switchAquecimentoMode = false;
    this.resetaExercicio();
    this.resetAllProgression();

    if (this.idTreino) {
      this.cadastrarTreino(false);
      modal.close("Close click");
    } else {
      this.filterLista();
      modal.close("Close click");
      this.toastr.success("Exercício Salvo com Sucesso!", "Tudo Certo!");
    }

    this.userProgressDB = await this.apiCall
      .get("me/userprogress/createTraining")
      .pipe(take(1))
      .toPromise();
    this.userProgressDB = this.userProgressDB.return;
    if (this.createdTraining != "true" && this.userProgressDB.progress == 1)
      await this.updateUserProgress();
  }

  async mockTreinoTutorial() {
    const self = this;
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    self.tipoSelecionado = self.tipos.find((x) => x.id == 1);
    self.toggleTipoTreino();
    self.newTraining.name = "Meu Primeiro Treino Personalizado";
    await self.spinner.hide();

    self.listaExercicios = [
      {
        tempId: 0,
        id: null,
        name: "Caminhada Na Esteira",
        url_video:
          "https://files.wecodde.com/file/wecodde/Caminhada+Na+Esteira.mp4",
        url_gif: null,
        series: 1,
        repetitions: null,
        duration: 300,
        load: null,
        speed: null,
        breakTime: 30,
        note: null,
        order: null,
        loadFeedback: null,
        repetitionFeedback: null,
        timeFeedback: null,
        category: 1,
        progressions: [],
        timeDuration: {
          hour: 0,
          minute: 5,
          second: 0,
        },
        showLoadFeedback: null,
        showRepetitionFeedback: null,
        showTimeFeedback: null,
        isAquecimento: null,
        conjugado: null,
        hideVariables: null,
        corporalLoad: null,
        inicio_youtube: null,
        fim_youtube: null,
        disabled: false,
      },
      {
        tempId: 1,
        id: null,
        name: "Prancha 4 Apoios",
        url_video:
          "https://files.wecodde.com/file/wecodde/Prancha+4+Apoios.mp4",
        url_gif: null,
        series: 1,
        repetitions: null,
        duration: 30,
        load: null,
        speed: null,
        breakTime: 20,
        note: null,
        order: null,
        loadFeedback: null,
        repetitionFeedback: null,
        timeFeedback: null,
        category: 12,
        progressions: [],
        timeDuration: {
          hour: 0,
          minute: 0,
          second: 30,
        },
        showLoadFeedback: null,
        showRepetitionFeedback: null,
        showTimeFeedback: null,
        isAquecimento: null,
        conjugado: null,
        hideVariables: null,
        corporalLoad: null,
        inicio_youtube: null,
        fim_youtube: null,
        disabled: false,
      },
      {
        tempId: 2,
        id: null,
        name: "Prancha Lateral 2 Apoios",
        url_video:
          "https://files.wecodde.com/file/wecodde/Prancha+Lateral+2+Apoios.mp4",
        url_gif: null,
        series: 1,
        repetitions: null,
        duration: 20,
        load: null,
        speed: null,
        breakTime: 20,
        note: null,
        order: null,
        loadFeedback: null,
        repetitionFeedback: null,
        timeFeedback: null,
        category: 12,
        progressions: [],
        timeDuration: {
          hour: 0,
          minute: 0,
          second: 20,
        },
        showLoadFeedback: null,
        showRepetitionFeedback: null,
        showTimeFeedback: null,
        isAquecimento: null,
        conjugado: null,
        hideVariables: null,
        corporalLoad: null,
        inicio_youtube: null,
        fim_youtube: null,
      },
    ];
    self.filterLista();
  }

  removerExercicio(exercicio) {
    const self = this;
    if (self.idTreino) {
      exercicio.deletedAt = true;
      self.listaExerciciosDeletadas.push(exercicio);
    }
    const index = self.listaExercicios.indexOf(exercicio);
    if (index > -1) {
      self.listaExercicios.splice(index, 1);
    }
    this.listaExerciciosFiltrados = [];
    this.listaExerciciosFiltrados = [
      ...this.listaExercicios.filter((x) => !x.hideVariables),
    ];
    this.resetAllProgression();
    if (this.idTreino) {
      this.cadastrarTreino(false);
    } else {
      this.filterLista();
    }
  }

  duplicarExercicio(exercicio) {
    let newExercicie = { ...exercicio };
    newExercicie.tempId = this.idExercicio++;
    newExercicie.id = null;
    this.listaExercicios.push(newExercicie);
    if (this.idTreino) {
      this.cadastrarTreino(false);
    } else {
      this.filterLista();
    }
  }

  modal;

  editarExercicio(exercicio, modalExercicio, modal) {
    this.modal = modal;

    if (this.idTreino && this.training && this.training.type == 4) {
      this.showFeedback = true;
    }

    this.listaExerciciosFiltrados = [];
    this.listaExerciciosFiltrados = [
      ...this.listaExercicios.filter((x) => !x.hideVariables),
    ];
    for (let e of this.listaExerciciosFiltrados) {
      e.disabled = false;
    }
    if (exercicio) {
      if (exercicio.tempId != null) {
        const foundE = this.listaExerciciosFiltrados.findIndex(
          (x) => x.tempId == exercicio.tempId
        );
        if (foundE > -1) {
          this.listaExerciciosFiltrados.splice(foundE, 1);
        }
      }
      for (let e of this.listaExerciciosFiltrados) {
        if (
          this.listaExerciciosFiltrados &&
          this.listaExerciciosFiltrados.find(
            (x) => x.conjugado != null && x.conjugado == e.tempId
          )
        ) {
          e.disabled = true;
        }
        if (e.conjugado == exercicio.tempId) {
          e.disabled = true;
        }
      }

      if (
        this.listaExerciciosFiltrados.length == 1 ||
        this.listaExerciciosFiltrados.filter((x) => !x.disabled).length == 1
      ) {
        let exToVerify =
          this.listaExerciciosFiltrados.length == 1
            ? this.listaExerciciosFiltrados[0]
            : this.listaExerciciosFiltrados.filter((x) => !x.disabled)[0];
        if (exToVerify) {
          let searchFront = { ...exToVerify };
          while (searchFront.conjugado != null) {
            for (let z of this.listaExercicios) {
              if (z.tempId == searchFront.conjugado) {
                searchFront = { ...z };
              }
            }
          }
          if (
            exercicio.tempId != null &&
            searchFront.tempId != null &&
            exercicio.tempId == searchFront.tempId
          ) {
            if (this.listaExerciciosFiltrados.length == 1) {
              this.listaExerciciosFiltrados[0].disabled == true;
            } else if (
              this.listaExerciciosFiltrados.filter((x) => !x.disabled).length ==
              1
            ) {
              for (let i of this.listaExerciciosFiltrados) {
                if (!i.disabled) i.disabled = true;
              }
            }
          }
        }
      }

      this.categoriaSelecionada = this.categoriesAndExercicies
        ? this.categoriesAndExercicies.find((c) => c.id == exercicio.category)
        : null;
      this.onselectCategory();
      this.exercicioSelecionado = this.exercicies
        ? this.exercicies.find((e) => e.Exercise.name == exercicio.name)
        : null;
      if (!this.exercicioSelecionado) {
        let exercicieTemp = {
          Exercise: {
            id: "x",
            name: exercicio.name,
            url_gif: exercicio.url_gif ? exercicio.url_gif : null,
            url_video: exercicio.url_video ? exercicio.url_video : null,
          },
        };
        this.exercicioSelecionado = exercicieTemp;
      }
      this.resetaExercicio();
      this.resetAllProgression();

      this.isEditingExercise = true;
      if (exercicio.duration) {
        this.switchRepetitionAndDuration = true;
      } else if (exercicio.repetitions) {
        this.switchRepetitionAndDuration = false;
      }

      if (exercicio.isAquecimento) {
        this.switchAquecimentoMode = true;
      } else {
        this.switchAquecimentoMode = false;
      }
      if (exercicio.url_video) {
        this.isVideo = true;
      } else {
        this.isVideo = false;
      }

      if (this.idTreino) {
        this.progressions = exercicio.TrainingExercisesProgressions;
      } else {
        this.progressions = exercicio.progressions;
      }

      let timeDuration = null;
      if (exercicio.duration) {
        exercicio.duration = Number(exercicio.duration);
        var h = Math.floor(exercicio.duration / 3600);
        var m = Math.floor((exercicio.duration % 3600) / 60);
        var s = Math.floor((exercicio.duration % 3600) % 60);
        timeDuration = { hour: h, minute: m, second: s };
      }

      this.exercicie = {
        tempId: exercicio.tempId,
        id: exercicio.id,
        name: exercicio.name,
        url_video: exercicio.url_video,
        url_gif: exercicio.url_gif,
        series: exercicio.series,
        repetitions: exercicio.repetitions,
        duration: exercicio.duration,
        load: exercicio.load,
        speed: exercicio.speed,
        breakTime: exercicio.breakTime,
        note: exercicio.note,
        order: exercicio.order,
        loadFeedback: exercicio.loadFeedbackSt
          ? exercicio.loadFeedbackSt
          : exercicio.loadFeedback,
        repetitionFeedback: exercicio.repetitionFeedback,
        timeFeedback: exercicio.timeFeedback,
        category: exercicio.category,
        progressions: exercicio.TrainingExercisesProgressions,
        timeDuration: timeDuration,
        showLoadFeedback: exercicio.showLoadFeedback,
        showRepetitionFeedback: exercicio.showRepetitionFeedback,
        showTimeFeedback: exercicio.showTimeFeedback,
        isAquecimento: exercicio.isAquecimento,
        conjugado: exercicio.conjugado,
        hideVariables: exercicio.hideVariables,
        corporalLoad: exercicio.corporalLoad,
        inicio_youtube: exercicio.inicio_youtube,
        fim_youtube: exercicio.fim_youtube,
        url_thumbnail: exercicio.url_thumbnail,
        exerciseId: this.exercicioSelecionado.Exercise.id,
      };
      if (this.exercicie.hideVariables) {
        this.switchHideVariables = true;
      } else {
        this.switchHideVariables = false;
      }

      if (this.progressions.length > 0) {
        this.switchPeriodizacaoMode = true;
      }
    }

    this.modalService.open(modalExercicio, { size: "xl" });
  }

  atualizarExercicio(modal) {
    if (this.exercicie) {
      this.listaExerciciosFiltrados = [];
      this.listaExerciciosFiltrados = [
        ...this.listaExercicios.filter((x) => !x.hideVariables),
      ];

      for (let e of this.listaExercicios) {
        if (e.tempId == this.exercicie.tempId) {
          if (this.exercicie.url_gif) {
            this.exercicie.url_video = null;
          } else {
            this.exercicie.url_gif = null;
          }
          e.tempId = this.exercicie.tempId;
          e.id = this.exercicie.id;
          e.name = this.exercicie.name;
          e.url_video = this.exercicie.url_video;
          e.url_gif = this.exercicie.url_gif;
          e.series = this.exercicie.series;
          e.showLoadFeedback = this.exercicie.showLoadFeedback;
          e.showTimeFeedback = this.exercicie.showTimeFeedback;
          e.isAquecimento = this.exercicie.isAquecimento;
          e.hideVariables = this.exercicie.hideVariables;
          e.showRepetitionFeedback = this.exercicie.showRepetitionFeedback;
          e.conjugado = this.exercicie.conjugado;
          e.corporalLoad = this.exercicie.corporalLoad;
          e.inicio_youtube = this.exercicie.inicio_youtube;
          e.fim_youtube = this.exercicie.fim_youtube;
          e.url_thumbnail = this.exercicie.url_thumbnail;

          if (this.switchRepetitionAndDuration) {
            this.exercicie.repetitions = null;
          } else {
            this.exercicie.duration = null;
            this.exercicie.timeDuration = null;
          }

          e.duration = this.exercicie.duration;
          e.repetitions = this.exercicie.repetitions;

          if (this.exercicie.timeDuration) {
            let totalSeconds = 0;
            if (this.exercicie.timeDuration.hour)
              totalSeconds =
                totalSeconds + this.exercicie.timeDuration.hour * 60 * 60;
            if (this.exercicie.timeDuration.minute)
              totalSeconds =
                totalSeconds + this.exercicie.timeDuration.minute * 60;
            if (this.exercicie.timeDuration.second)
              totalSeconds = totalSeconds + this.exercicie.timeDuration.second;
            e.duration = totalSeconds;
          }

          e.load = this.exercicie.load;
          e.speed = this.exercicie.speed;
          e.breakTime = this.exercicie.breakTime;
          e.note = this.exercicie.note;
          e.order = this.exercicie.order;
          e.loadFeedback = this.exercicie.loadFeedback;
          e.repetitionFeedback = this.exercicie.repetitionFeedback;
          e.timeFeedback = this.exercicie.timeFeedback;
          e.category = this.exercicie.category;
          let progressionsToSend = [];
          if (this.progressions) {
            for (let p of this.progressions) {
              progressionsToSend.push(p);
            }
          }

          if (this.progressionsDeletadas) {
            for (let p of this.progressionsDeletadas) {
              progressionsToSend.push(p);
            }
          }

          e.progressions = progressionsToSend;
          if (this.exercicie.conjugado != null) {
            e.breakTime = 0;
          }
        }
      }

      if (this.exercicie.conjugado != null) {
        if (
          this.listaExercicios &&
          this.listaExercicios.find((x) => x.conjugado == null)
        ) {
          let searchFront = { ...this.exercicie };
          while (searchFront.conjugado != null) {
            for (let z of this.listaExercicios) {
              if (z.tempId == searchFront.conjugado) {
                z.series = searchFront.series;
                z.isAquecimento = searchFront.isAquecimento;
                searchFront = { ...z };
              }
            }
          }
          let searchBack = { ...this.exercicie };
          while (
            this.listaExercicios &&
            this.listaExercicios.find((x) => x.conjugado == searchBack.tempId)
          ) {
            for (let z of this.listaExercicios) {
              if (z.conjugado == searchBack.tempId) {
                z.series = searchBack.series;
                z.isAquecimento = searchBack.isAquecimento;
                searchBack = { ...z };
              }
            }
          }
        }
      }

      let allExerciciesToUpdate = [];
      for (let a of this.conjugados) {
        if (a.list && a.list.find((x) => x.tempId == this.exercicie.tempId)) {
          for (let t of a.list) {
            t.series = this.exercicie.series;
            allExerciciesToUpdate.push(t);
          }
        }
      }
      if (allExerciciesToUpdate.length > 0) {
        for (let z of this.listaExercicios) {
          let found = allExerciciesToUpdate.find((x) => x.tempId == z.tempId);
          if (found) {
            z.series = found.series;
          }
        }
      }

      this.cancelarAtualizacaoExercicio();

      if (this.idTreino) {
        this.cadastrarTreino(false);
        modal.close("Close click");

        if (this.modal) {
          this.modal.close("Close click");
        }
      } else {
        this.filterLista();
        modal.close("Close click");
        this.toastr.success("Exercicio salvo com sucesso", "Tudo Certo!");
      }
    }
  }

  onselectModel() {
    if (this.trainingModelselecionada) {
      this.preencheInputsTreino(this.trainingModelselecionada);
    } else {
      if (!this.idTreino) {
        this.nomeTreino = null;
        this.listaExercicios = [];
        this.listaRequisicoes = [];
      }
    }
  }

  cancelaTreino() {
    this._location.back();
  }

  cancelarAtualizacaoExercicio() {
    this.listaExerciciosFiltrados = [];
    this.listaExerciciosFiltrados = [];
    this.listaExerciciosFiltrados = [
      ...this.listaExercicios.filter((x) => !x.hideVariables),
    ];
    for (let e of this.listaExerciciosFiltrados) {
      e.disabled = false;
    }
    for (let e of this.listaExerciciosFiltrados) {
      if (
        this.listaExerciciosFiltrados &&
        this.listaExerciciosFiltrados.find(
          (x) => x.conjugado != null && x.conjugado == e.tempId
        )
      ) {
        e.disabled = true;
      }
    }
    this.isEditingExercise = false;
    this.resetaExercicio();
    this.resetAllProgression();
    this.switchRepetitionAndDuration = true;
    this.switchHideVariables = false;
    this.categoriaSelecionada = null;
    this.exercicioSelecionado = null;
    this.showFeedback = false;
    this.exercicies = [];
  }

  async cadastrarTreino(locationBack) {
    if (this.listaExercicios) {
      let listaParaEnviar = [];
      for (let e of this.listaExercicios) {
        e.order = this.listaExercicios.indexOf(e) + 1;
        if (e.progressions) {
          for (let p of e.progressions) {
            if (p.progressionDate)
              p.progressionDate = moment(
                p.progressionDate,
                "YYYY-MM-DD"
              ).toDate();
          }
        }
        listaParaEnviar.push(e);
      }
      for (let e of this.listaExerciciosDeletadas) {
        listaParaEnviar.push(e);
      }
      this.newTraining.exercises = listaParaEnviar;
      this.newTraining.type = this.tipoSelecionado.id;

      if (this.group) {
        this.newTraining.sellerCustomer = null;
        this.newTraining.isModel = false;
        this.newTraining.isExperimental = false;
        this.newTraining.group = this.group;
      } else if (this.isModel) {
        this.newTraining.isModel = true;
        this.newTraining.isExperimental = false;
        this.newTraining.sellerCustomer = null;
        this.newTraining.group = null;
      } else if (this.relation) {
        this.newTraining.sellerCustomer = this.relation;
        this.newTraining.group = null;
        this.newTraining.isModel = false;
        this.newTraining.isExperimental = false;
      }

      if (this.newTraining.breakTime) {
        let totalSeconds = 0;
        if (this.newTraining.breakTime.hour)
          totalSeconds =
            totalSeconds + this.newTraining.breakTime.hour * 60 * 60;
        if (this.newTraining.breakTime.minute)
          totalSeconds = totalSeconds + this.newTraining.breakTime.minute * 60;
        if (this.newTraining.breakTime.second)
          totalSeconds = totalSeconds + this.newTraining.breakTime.second;
        this.newTraining.breakTime = totalSeconds;
      }

      if (this.agendamento) {
        this.newTraining.agendamento = moment(
          this.agendamento,
          "DD-MM-YYYY"
        ).toDate();
      }

      if (this.vencimento) {
        this.newTraining.vencimento = moment(
          this.vencimento,
          "DD-MM-YYYY"
        ).toDate();
      }
      let chamada;
      let urlChamada = null;
      if (!this.isModel && !this.group && this.relation) {
        urlChamada = "training/personal/" + this.relation;
      } else {
        urlChamada = "training/personal/0";
      }
      if (!urlChamada) {
        return;
      }

      if (this.idTreino) {
        chamada = this.apiCall.put(urlChamada, { training: this.newTraining });
      } else {
        chamada = this.apiCall.post(urlChamada, { training: this.newTraining });
      }
      this.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      chamada.subscribe(async (data) => {
        if (data.success) {
          if (this.idTreino) {
            this.idExercicio = 0;
            this.preencheInputsTreino(data.return);
          }
          this.preparaAssociacao();
          this.filterLista();

          this.conjugadosToAdmin.list = [...this.conjugadosToAdmin.list];

          this.spinner.hide();
          if (this.isOnTour) {
            this.introJS.nextStep();
          } else {
            this.toastr.success(
              this.idTreino
                ? "Seu treino foi atualizado com sucesso"
                : "Seu treino foi cadastrado com sucesso",
              "Tudo Certo!"
            );
            if (locationBack) this._location.back();
            if (!this.idTreino) {
              this.userProgressDB = await this.apiCall
                .get("me/userprogress/createTraining")
                .pipe(take(1))
                .toPromise();
              this.userProgressDB = this.userProgressDB.return;
              if (
                this.createdTraining != "true" &&
                this.userProgressDB.progress == 2
              ) {
                await this.updateUserProgress();
                this.apiCall
                  .put("me/userparams/createdTraining")
                  .pipe(take(1))
                  .toPromise();
              }
            }
          }
        } else {
          await this.app.alert("Ops :(", data.message, "error");
          this.spinner.hide();
        }
      });
    }
  }

  OpenModalXl(content) {
    this.modalService.open(content, { centered: true, size: "xl" });
  }

  copyToClipboard(text: string, fieldName?: string) {
    const result = this.clipboardApi.copyFromContent(text);

    if (result) {
      this.toastr.success(
        `${fieldName || "Conteúdo"} copiado com sucesso!`,
        "Copiado!"
      );
    } else {
      this.toastr.error(
        `Não foi possível copiar o ${fieldName || "Conteúdo"}!`,
        "Ops!"
      );
    }
  }

  viewMidiaTutorial(urlToPlay, content) {
    this.urlToPlay = urlToPlay;
    if (urlToPlay.startsWith("https://www.youtube.com/watch?")) {
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
        urlToPlay.replace(
          "https://www.youtube.com/watch?v=",
          "https://www.youtube.com/embed/"
        )
      );
    } else if (urlToPlay.startsWith("http://www.youtube.com/watch?")) {
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
        urlToPlay.replace(
          "http://www.youtube.com/watch?v=",
          "https://www.youtube.com/embed/"
        )
      );
    }
    this.modalService.open(content, { centered: true, size: "lg" });
  }
}

const getTourLastStepContent = ({
  email,
  password,
}: {
  email: string;
  password: string;
}) =>
  `<div class="row"> <div class="col-12"> <span class="d-block text-center"> <b>Parabéns!</b> <br /> Você criou seu primeiro treino! <b>Baixe o app do aluno</b> para ver através da perspectiva do aluno. </span> </div> <div class="col-12 mt-3"> <div class="w-100 d-flex flex-column align-items-start"> <div class="w-100 d-flex flex-column align-items-start justify-content-start download-app__credential-field" > <div class="d-flex justify-content-start align-items-center"> <span class="d-block text-bold-600 text-left font-size-5"> Email: </span> <button id="copy-customer-email" type="button" title="Copiar email" class="btn btn-sm btn-outline-secondary py-0 border-0 ml-2" > <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14" viewBox="0 0 32 32" data-name="Layer 1" id="Layer_1" > <title /> <path d="M27.2,8.22H23.78V5.42A3.42,3.42,0,0,0,20.36,2H5.42A3.42,3.42,0,0,0,2,5.42V20.36a3.43,3.43,0,0,0,3.42,3.42h2.8V27.2A2.81,2.81,0,0,0,11,30H27.2A2.81,2.81,0,0,0,30,27.2V11A2.81,2.81,0,0,0,27.2,8.22ZM5.42,21.91a1.55,1.55,0,0,1-1.55-1.55V5.42A1.54,1.54,0,0,1,5.42,3.87H20.36a1.55,1.55,0,0,1,1.55,1.55v2.8H11A2.81,2.81,0,0,0,8.22,11V21.91ZM28.13,27.2a.93.93,0,0,1-.93.93H11a.93.93,0,0,1-.93-.93V11a.93.93,0,0,1,.93-.93H27.2a.93.93,0,0,1,.93.93Z" /> </svg> </button> </div> <div class="w-100 d-flex mt-2"> <div class="w-100 px-3 py-1 border bg-white d-flex justify-content-start rounded-pill shadow-sm" > <span class="font-size-5 truncate"> ${email} </span> </div> </div> </div> <div class="w-100 d-flex flex-column align-items-start justify-content-start download-app__credential-field mt-3" > <div class="d-flex justify-content-start align-items-center"> <span class="d-block text-bold-600 text-left font-size-5"> Senha: </span> <button id="copy-customer-password" type="button" title="Copiar senha" class="btn btn-sm btn-outline-secondary py-0 border-0 ml-2" > <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14" viewBox="0 0 32 32" data-name="Layer 1" > <title /> <path d="M27.2,8.22H23.78V5.42A3.42,3.42,0,0,0,20.36,2H5.42A3.42,3.42,0,0,0,2,5.42V20.36a3.43,3.43,0,0,0,3.42,3.42h2.8V27.2A2.81,2.81,0,0,0,11,30H27.2A2.81,2.81,0,0,0,30,27.2V11A2.81,2.81,0,0,0,27.2,8.22ZM5.42,21.91a1.55,1.55,0,0,1-1.55-1.55V5.42A1.54,1.54,0,0,1,5.42,3.87H20.36a1.55,1.55,0,0,1,1.55,1.55v2.8H11A2.81,2.81,0,0,0,8.22,11V21.91ZM28.13,27.2a.93.93,0,0,1-.93.93H11a.93.93,0,0,1-.93-.93V11a.93.93,0,0,1,.93-.93H27.2a.93.93,0,0,1,.93.93Z" /> </svg> </button> </div> <div class="w-100 d-flex mt-2"> <div class="w-100 px-3 py-1 border bg-white d-flex justify-content-start rounded-pill shadow-sm" > <span class="font-size-5 truncate"> ${password} </span> </div> </div> </div> </div> </div> <div class="col-12 mt-3"> <div class="d-flex justify-content-center"> <a href="https://play.google.com/store/apps/details?id=br.com.personaldigital" target="_blank" rel="noopener noreferrer" class="w-100 btn btn-store-download shadow-none d-flex justify-content-center align-items-center px-3 py-1" > <img src="../../assets/img/play_store_logo.svg" alt="Play Store" class="store-download-icon play-store" /> <div class="d-flex flex-column align-items-start ml-2"> <span class="font-size-3">Download na</span> <span class="font-size-4 text-bold-600">Google Play</span> </div> </a> </div> <div class="mt-2 d-flex justify-content-center"> <a href="https://apps.apple.com/br/app/o-personal-digital/id1532310171" target="_blank" rel="noopener noreferrer" class="w-100 btn btn-store-download shadow-none d-flex justify-content-center align-items-center px-3 py-1" > <img src="../../assets/img/apple_logo.svg" alt="App Store" class="store-download-icon" /> <div class="d-flex flex-column align-items-start ml-2"> <span class="font-size-3">Download na</span> <span class="font-size-4 text-bold-600">App Store</span> </div> </a> </div> </div></div>`;
